import { ActionType } from "../actions/actionTypes";

type AuthState = {
  token: string | null;
  username: string | null;
};

const INITIAL_STATE: AuthState = {
  token: null,
  username: null
};

export default (
  state: AuthState = INITIAL_STATE,
  action: ActionType
): AuthState => {
  switch (action.type) {
    case "SET_AUTH": {
      return {
        ...state,
        token: action.payload.token,
        username: action.payload.username
      };
    }
    case "CLEAR_AUTH": {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
};
